import "./AccordeonComponentStyles.scss";
import { FC, useState } from "react";
// Asegúrate de que esta importación trae la nueva propiedad
import AccordeonComponentProps from "./AccordeonComponentProps";
import Icons from "../../assets/Icons";

const AccordeonComponent: FC<AccordeonComponentProps> = ({
    title,
    subtitle,
    options,
    allOpenByDefault = false, // 👈 Establecer valor por defecto a false
}) => {
    // Si allOpenByDefault es true, no usamos el estado 'open' para controlar.
    // Usamos el estado para el modo 'un solo acordeón abierto'.
    const [open, setOpen] = useState<number | undefined>(undefined);

    const _handleOpen = (index: number) => {
        // Esta lógica solo se ejecuta si NO están todos abiertos por defecto
        if (!allOpenByDefault) {
            if (open === index) setOpen(undefined);
            else setOpen(index);
        }
    };

    // Función auxiliar para determinar si un ítem debe estar abierto
    const isOpen = (index: number): boolean => {
        // 1. Si la prop es true, TODOS están abiertos.
        if (allOpenByDefault) {
            return true;
        }
        // 2. Si la prop es false, usamos el estado normal del acordeón (uno a la vez).
        return open === index;
    };

    return (
        <div className="accordeon_component">
            <div className="w-100">
                {title && <div className="side side_top">{title}</div>}
                <div className="container p-0">
                    {subtitle && <div className="pb-5">{subtitle}</div>}
                    {options.map((option, index) => {
                        // Usamos la función auxiliar
                        const active = isOpen(index);

                        if (option?.showOption ?? true) {
                            return (
                                // Usamos 'active' para aplicar la clase CSS
                                <div className={`item ${active && "active"}`} key={index}>
                                    <div
                                        className="header"
                                        // El onClick solo se habilita si no están todos abiertos por defecto
                                        onClick={!allOpenByDefault ? () => _handleOpen(index) : undefined}
                                        // Opcional: Estilo para indicar que no es clickeable cuando están todos abiertos
                                        style={allOpenByDefault ? { cursor: "default" } : {}}
                                    >
                                        {typeof option.title === "string" ? (
                                            <h2 className="title ms-3 fs-5">{option.title}</h2>
                                        ) : (
                                            option.title
                                        )}
                                        <div className="me-3">
                                            {/* El icono siempre debe reflejar el estado 'active' */}
                                            {active ? (
                                                <Icons.Clear height={25} width={25} />
                                            ) : (
                                                <Icons.Plus height={25} width={25} />
                                            )}
                                        </div>
                                    </div>
                                    {/* El contenido se muestra si 'active' es true */}
                                    <div className={`${active ? "content" : "d-none"} py-3 mx-3 mx-md-4`}>
                                        {option.content}
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
};

export default AccordeonComponent;
